/**
 * Method checks if user has permission to see unassigned conversations.
 * @param {*} permissionRoles permissionRole state
 * @param {*} merchant merchant state
 */
function userHasPermissionToListUnassignedConversations(permissionRoles, role, rootGetters) {
  return rootGetters['user/incognito'] || role === 'owner' || (permissionRoles.list_unassigned_conversations && permissionRoles.list_unassigned_conversations.includes(role));
}

/**
 * Method checks if user has permission to see assigned conversations.
 * @param {*} permissionRoles permissionRole state
 * @param {*} merchant merchant state
 */
function userHasPermissionToListOthersAssignedConversations(permissionRoles, role, rootGetters) {
  return rootGetters['user/incognito'] || role === 'owner' || (permissionRoles.list_others_assigned_conversations && permissionRoles.list_others_assigned_conversations.includes(role));
}

function checkPermission(permissionToCheck, rootGetters) {
  const permissions = rootGetters['user/userPermissions'];
  const currentOrganisationId = rootGetters['organisation/currentOrganisation'].id;
  const incognito = rootGetters['user/incognito'];

  return (
    (
      incognito &&
      incognito[currentOrganisationId]
    ) ||
    (
      permissions &&
      permissions[currentOrganisationId] &&
      permissions[currentOrganisationId].includes(permissionToCheck)
    )
  );
}

export { userHasPermissionToListUnassignedConversations, userHasPermissionToListOthersAssignedConversations, checkPermission };
